import { render, staticRenderFns } from "./PriceListListView.vue?vue&type=template&id=c663826e"
import script from "./PriceListListView.vue?vue&type=script&lang=js"
export * from "./PriceListListView.vue?vue&type=script&lang=js"
import style0 from "./PriceListListView.vue?vue&type=style&index=0&id=c663826e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports